module.exports = __webpack_public_path__ + "static/media/1.4680ae7b.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/denied/1.mp3
// module id = 476
// module chunks = 0